import {action, observable, runInAction, makeObservable} from 'mobx';
import {message, notification} from 'antd'
import {request} from '@/framework/network/request'
import * as session from '@/framework/network/session'
import customHistory from '@/framework/customHistory'
import Company from '@/feature/ucenter/user/model/Company'
import WebSessionUser from '../model/WebSessionUser'

export default class AppStore {

    loading: boolean;
    logged: boolean;
    loginDivState: boolean
    loginOrRegister: boolean;
    agreementDivState: boolean;
    popupState: boolean;
    user: WebSessionUser;
    company: Company;

    constructor() {
        makeObservable(this, {
            loading: observable,
            logged: observable,
            loginDivState: observable,
            loginOrRegister: observable,
            agreementDivState: observable,
            popupState: observable,
            user: observable,
            company: observable,
            login: action,
            logout: action,
            fetchCurrentUser: action,
            register: action,
            setLoginDivState: action,
            setLoginOrRegister: action,
            setPopupState: action,
            setAgreementDivState: action
        });

        this.loading = false
        this.logged = false
        this.loginDivState = false
        this.loginOrRegister = true
        this.popupState = false
        this.agreementDivState = false
        this.user = new WebSessionUser()
        this.company = new Company()
    }

    login = async (values: any) => {
        this.loading = true
        try {
            const res = await request.post('/login', values)
            console.log(res)
            if (res.status === 0) {
                if (res.code === '0') {
                    notification.error({message: '登录失败', description: '用户名不存在！'})
                } else if (res.code === '101') {
                    notification.error({message: '登录失败', description: '密码错误！'})
                }
            } else {
                await this._loginSuccess(res.data.token)
                runInAction(() => {
                    this.loginDivState = false;
                    this.user = res.data
                    this.loading = false
                })
            }
            runInAction(() => {
                this.loading = false
            })
        } catch (e) {
            notification.error({
                message: 'error',
                description: e.message
            })
        }
    };

    logout = async () => {
        await request.get(`/logout`)
        runInAction(() => {
            this.logged = false
            this.user = new WebSessionUser()
            this.company = new Company()
        })
        session.logout()
        // customHistory.push(config.loginSuccessPath)
        customHistory.push('/')
    };

    fetchCurrentUser = async () => {
        this.loading = true
        try {
            const res = await request.get(`/current/user`)
            const resCount = await request.get(`/cart:count`)
            runInAction(() => {
                this.user = res.data
                this.user.cartCount = resCount.data
                this.company = res.data.company
                this.logged = true
            })
        } catch (e) {
            runInAction(() => {
                this.logged = false
            })
        }
        runInAction(() => {
            this.loading = false
        })
    };


    _loginSuccess = async (token: string) => {
        session.loginSuccess(token)
        // customHistory.push(config.loginSuccessPath)
        message.success('登陆成功！', 3);
        runInAction(() => {
            this.logged = true
        })
    }

    register = async (values: any) => {
        this.loading = true
        try {
            const res = await request.post('/register', values)
            if (res.status === 0) {
                notification.error({message: '注册失败', description: res.msg})
                runInAction(() => {
                    this.loading = false
                })
            } else {
                notification.success({message: '注册成功,请登录!'})
                runInAction(() => {
                    this.loading = false
                })
                // customHistory.push("/")
                this.loginOrRegister = true
                this.loginDivState = true
            }
        } catch (e) {
            notification.error({
                message: 'error',
                description: e.message
            })
        }
    }

    setLoginDivState = (value: boolean) => {
        this.loginDivState = value
    }

    setLoginOrRegister = (value: boolean) => {
        this.loginOrRegister = value
    }

    setPopupState = (values: boolean) => {
        this.popupState = values
    }

    setAgreementDivState = (values: boolean) => {
        this.agreementDivState = values
    }
}
